<div class="marquee-container">
    <span id="marquee_alert" class="marquee d-flex justify-content-end text-secondary flex-none text-danger marquee_animation">{{param_alert}}</span>
</div>